<div class="cm-container">
    <div class="cm-sidebar-scroll-container">
        <div class="cm-sidebar-card">
            <div class="cm-sidebar-content">
                <cm-entity-responsive-sidebar class="cm-entity-sidebar">
                    <ng-content select="[cm-tabs]"></ng-content>
                    <ng-content select="[cm-filters]"></ng-content>
                </cm-entity-responsive-sidebar>
            </div>
        </div>
    </div>
    <div class="cm-main-scroll-container">
        <div class="cm-main-card">
            <div class="cm-main-content">
                <ng-content></ng-content>
                <cm-infinite-scroll-anchor></cm-infinite-scroll-anchor>
            </div>
        </div>
    </div>
</div>
